import localStorage from '@/api/localStorage'
import { userAuthenticat } from '@/api'
import { menus } from '@/api'
import { LOGOUT_ACCOUNT, CHECK_AUTH_ON_LOAD, WON_HEADER_MENU, FOOTER_MENU } from '@/store/actions.type'
import { LOAD_WON_HEADER_MENU, LOAD_WON_FOOTER_MENU } from '@/store/mutations.type'
import { urlParam } from '@/helper'

import store from '@/store/modules/app.settings'
import ApiService from '@/api'
const localStorageData = token()
const state = {
    headermenu: '',
    errors: null,
    tokenId: tokenid(),
    isAuthenticated: checkAuthention(),
    user: getCurrentUserdata()
}
function getCurrentUserdata() {
    var obj = {}
    if (localStorageData) {
        obj['email'] = JSON.parse(localStorageData).email
        obj['username'] = JSON.parse(localStorageData).username
    }
    return obj
}
function tokenid() {
    if (localStorageData) {
        var tokenid = JSON.parse(localStorageData).tokenid
        ApiService.setHeader(tokenid)
        var dec = window.atob(tokenid)
        var outputsrc = JSON.parse(dec)
        dtm['userID'] = outputsrc

        return tokenid
    } else {
        return null
    }
}
function checkAuthention() {
    if (localStorageData) {
        dtm['authenticated'] = 1
        return true
    } else {
        dtm['authenticated'] = 0
        return false
    }
}
function token() {
    // console.log(this.$route)
    var localStorageKey = 'userData'
    if (store.state.panaray) {
        localStorageKey = 'userData_p'
    }
    return localStorage.getlocalStorage(localStorageKey)
}

const getters = {
    currentUser(state) {
        return state.user
    },
    isAuthenticated(state) {
        return state.tokenId !== null
    }
}
const actions = {
    [CHECK_AUTH_ON_LOAD]({ commit }) {
        return new Promise((resolve, reject) => {
            var encemailid = ''
            if (urlParam.e) {
                if (typeof urlParam.e === 'object') {
                    encemailid = decodeURIComponent(urlParam.e[urlParam.e.length - 1])
                } else {
                    encemailid = decodeURIComponent(urlParam.e)
                }
                userAuthenticat.login(encemailid, 'userData_p').then(({ data }) => {
                    resolve()
                })
                /* var auth = userAuthenticat.login(encemailid, 'userData_p')
                                                                if (auth) {
                                                                    console.log('auth', auth)
                                                                    resolve()
                                                                } */
            } else {
                resolve()
            }
        })
    },
    [LOGOUT_ACCOUNT]({ commit }) {
        return localStorage.destroyLocalStorage('userData')
    },
    async [WON_HEADER_MENU]({ commit }) {
        return menus.getheadermenu().then(({ data }) => {
            commit(LOAD_WON_HEADER_MENU, data)
        })
    },
    async [FOOTER_MENU]({ commit }) {
        return menus.getfootermenu().then(({ data }) => {
            commit(LOAD_WON_FOOTER_MENU, data)
        })
    }
}
const mutations = {
    [LOAD_WON_HEADER_MENU](state, headermenu) {
        state.headermenu = headermenu
    },
    [LOAD_WON_FOOTER_MENU](state, headermenu) {
        state.footermenu = headermenu
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js